import { BaseCacheService } from "mrb/core/cache";
import { DayHourService } from "common/services";

class DayHourCacheService extends BaseCacheService {
    constructor(rootStore) {
        super("day-hour", "lookup", async () => {
            const response = await this.service.get();
            return response.data;
        });
        this.service = rootStore.createApplicationService(DayHourService);
    }
}

export default DayHourCacheService;
